module.exports = __webpack_public_path__ + "static/media/OpenSans-BoldItalic.3a811373.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/OpenSans/OpenSans-BoldItalic.ttf
// module id = 309
// module chunks = 0